exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@media (max-width:64em){.userBody__2ID8q{padding:.7em}}@media (max-width:30em){.userBody__2ID8q{padding:.5em}}", "", {"version":3,"sources":["/home/runner/work/web-support-widget/web-support-widget/src/components/User/index.scss"],"names":[],"mappings":"AAEE,wBAFF,iBAGI,YAAc,CAMjB,CAHC,wBANF,iBAOI,YAAc,CAEjB,CAAA","file":"index.scss","sourcesContent":[".userBody {\n\n  @media (max-width: 64em) {\n    padding: 0.7em;\n  }\n\n  @media (max-width: 30em) {\n    padding: 0.5em;\n  }\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"userBody": "userBody__2ID8q"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/User/index.scss
// module id = AmZ6
// module chunks = 0